import React, { Component } from 'react';
import { Row, Col, Button, Input } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import ContentWrapper from '../Layout/ContentWrapper';

const inputStyle = {
  height: '100%',
  width: '100%',
  borderRadius: '2px',
  backgroundColor: 'transparent'
};

class SerialNumModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      rowsToDelete: 0,
      finished: false,
      oldLoaded: 0,
      changed: false,
      serialNums: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
      selectedNumIdx: 1,
      selectedSerialNum: '',
      selectedRows: [],
      serialArrData: []
    };
  }

  componentDidMount() {
    let rows = []
    let currentSerialNo = this.props.currentSerialNo ? this.props.currentSerialNo.split(',') : [];
    let serialArrData = this.props.serialArrData ? this.props.serialArrData : []
    for (let i = 0; i < this.props.totalLoaded; i++) {
      if (this.props.isCheckAble) { 
        rows.push({ Num: currentSerialNo[i] || '', isSelected: serialArrData && serialArrData[i] && serialArrData[i].isSelected || false });
      } else {
        rows.push({ Num: currentSerialNo[i] || '' });
      }     
    }
    const serialNums = { ...this.state.serialNums, rows };
    this.setState({ serialNums, rows });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.totalLoaded && nextProps.totalLoaded !== this.props.totalLoaded) {
      const currentRowsCount = this.state.serialNums.rows.length;
      if (nextProps.totalLoaded > currentRowsCount) {
        const rows = this.state.serialNums.rows;
        this.setState({
          serialNums: {
            ...this.state.serialNums,
            rows: rows.concat(
              Array(nextProps.totalLoaded - currentRowsCount).map(() => ({Num: ''}))
            )
          }
        });
      }
      if (nextProps.totalLoaded < currentRowsCount) {
        this.state.serialNums.rows.length = nextProps.totalLoaded;
        this.setState({
          serialNums: {
            ...this.state.serialNums,
            rows: [...this.state.serialNums.rows]
          }
        });
      }
    }
    if (nextProps.currentSerialNo && nextProps.currentSerialNo !== this.props.currentSerialNo) {
      let newSerialNo = nextProps.currentSerialNo.split(',');
      this.setState({
        serialNums: {
          ...this.state.serialNums,
          rows: newSerialNo
        }
      });
    }
  }

  componentWillUnmount() {
    // if (!this.state.changed) {
    //   this.props.keepLoaded(this.props.oldLoaded || this.state.oldLoaded);
    // }
  }

  clearAllValues() {
    const newNums = [...this.state.serialNums.rows];
    newNums.map((row) => {
      row.Num = '';
    });

    const serialNums = { ...this.state.serialNums, rows: newNums }
    this.setState({ serialNums })
  }

  handleKeyPress = (event) => {
    if (event.charCode === 13 && this.state.selectedSerialNum) {
      event.preventDefault();
      const serialNums = { ...this.state.serialNums };

      if (this.state.selectedNumIdx === this.state.serialNums.rows.length){
        serialNums.rows[this.state.selectedNumIdx - 1].Num = this.state.selectedSerialNum;
        this.setState({ selectedSerialNum: '', selectedNumIdx: 0, serialNums})
      } else if (this.state.selectedNumIdx) {
        serialNums.rows[this.state.selectedNumIdx - 1].Num = this.state.selectedSerialNum;
        this.setState({ selectedSerialNum: '', selectedNumIdx: (this.state.selectedNumIdx+1), serialNums})
      } else {
        this.setState({ selectedSerialNum: '', selectedNumIdx: (this.state.selectedNumIdx+1) }, () => { this.handleFinish(); });
      }
    } else if (event.charCode === 13 && this.state.selectedNumIdx === 0){
      this.setState({ selectedSerialNum: '', selectedNumIdx: (this.state.selectedNumIdx+1) }, () => { this.handleFinish(); });
    }
  }

  handleChangeSerialNo = (event, selectedNumIdx) => {
    let cpRows = [];
    this.state.serialNums.rows.map((item, index) => {
      if(index == selectedNumIdx-1) {
        cpRows.push({...item, Num: event.target.value})
      } else {
        cpRows.push(item)
      }
    })
    this.setState({
      serialNums: {...this.state.serialNums, rows: cpRows}
    }, () => {
      let name = 'serialNum'+selectedNumIdx;
      var inputElement = document.querySelector(`[name=${name}]`)
      inputElement.style.border = '2px solid #2160c7'
      inputElement.focus();
    })
  }

  handleSerialNoFocus = (event, selectedNumIdx) => {
    let name = 'serialNum'+selectedNumIdx;
    if(event.keyCode == 13 || event.keyCode == 40){// 回车 ｜ 下箭头
      if(selectedNumIdx == this.state.serialNums.rows.length) {
        var inputElement = document.querySelector(`[name=${name}]`)
        inputElement.blur();
      } else {
        name = 'serialNum'+(selectedNumIdx + 1);
        var inputElement = document.querySelector(`[name=${name}]`)
        inputElement.style.border = '2px solid #2160c7'
        inputElement.focus();
        let length = inputElement.value ? inputElement.value.length : 0;
        inputElement.setSelectionRange(length, length);
      }
      return
    }
    if(event.keyCode == 38) { // 上箭头
      if(selectedNumIdx == 1) return
      name = 'serialNum'+(selectedNumIdx - 1);
      var inputElement = document.querySelector(`[name=${name}]`)
      inputElement.style.border = '2px solid #2160c7'
      inputElement.focus();
      let length = inputElement.value ? inputElement.value.length : 0;
      inputElement.setSelectionRange(length, length);
    }
  } 

  renderNumInputs() {
    const getRows = () => Data.Selectors.getRows(this.state.serialNums);

    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx+1 }, rows[rowIdx]);
    };

    const onRowsSelected = (rows) => {
      let newRows = getRows();
      let selectedRows = [...this.state.selectedRows];
      rows.map(r => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
      });
      this.setState({ rows: newRows, selectedRows, serialArrData: newRows });
    }
    const onRowsDeselected = (rows) => {
      let newRows = [...this.state.rows];
      let selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
          const rowIndex = selectedRows.indexOf(r.row);
          selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows, serialArrData: newRows });
  }

    const that = this;

    const columns = [
      {
        key: 'Idx',
        name: <Translate value="index" />,
        width: 50,
        resizable: false,
        filterable: true,
      },
      {
        key: 'Num',
        name: <Translate value="serial_no" />,
        width: 354,
        getRowMetaData: row => row,
        formatter: ({value, dependentValues})=> {
          return this.props.isCheckAble ? <span> {value} </span> : <input
          style={inputStyle}
          type="text"
          name={"serialNum"+dependentValues.Idx}
          value={value}
          onClick={(event)=>{
            event.stopPropagation();
            let name = 'serialNum'+ dependentValues.Idx;
            var inputElement = document.querySelector(`[name=${name}]`)
            inputElement.style.border = '2px solid #2160c7'
            inputElement.focus();
          }}
          onBlur={()=>{
            let name = 'serialNum'+ dependentValues.Idx;
            var inputElement = document.querySelector(`[name=${name}]`)
            inputElement.style.border = 'none'
          }}
          onChange={(event)=>{
            that.handleChangeSerialNo(event, dependentValues.Idx)
          }}
          onKeyDown={(event) =>{
            this.handleSerialNoFocus(event, dependentValues.Idx);
          }
          }
        />
        }
      },
    ];
 
    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: '99%' }}>
            {
                <div id="SetNumModal-dataGrid3">
                  <ReactDataGrid
                    style={{ height: '10%' }}
                    columns={columns}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={275}
                    rowSelection={{
                      showCheckbox: this.props.isCheckAble,
                      onRowsSelected,
                      onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected',
                      },
                    }}

                  />
                </div>
            }
          </div>
        </Col>
      </Row>
    );
  }

  handleFinish = () => {
    const rows = [];
    this.state.serialNums.rows.map((row, index) => {
      if (row.Num) {
        if (this.props.isCheckAble) {
          rows.push({Num: row.Num, isSelected: row.isSelected});
        } else {
          rows.push(row.Num)
        }
      }
    });
    if (this.props.isCheckAble) {
      this.props.returnSerialNums(rows.filter(item => item.isSelected).map(item => item.Num).join(','));
      this.props.getSerialArr(rows)
    } else {
      this.props.returnSerialNums(rows.join(','));
    }
    this.setState({ changed: true }, () => { this.props.closeC(); });
    if (this.props.isCheckAble) {
      this.props.setSerialNums(rows.filter(item => item.isSelected).length)
    } else {
      this.props.setSerialNums(rows.length)
    }
  }

  render() {
    const currentRows = this.state.serialNums.rows;
    const canSave = currentRows.every(row => !!row.Num) && (this.props.isCheckAble ? currentRows.filter(item => item.isSelected).length === this.props.checkNum : true)
    return (
      <ContentWrapper>
        {this.renderNumInputs()}
        <br/>
        <br/>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', width:'100%'}}>
            { !this.props.isCheckAble && <button className="btn btn-danger col-sm-3 buttonStyle" type="button" onClick={() => { this.clearAllValues(); }}><Translate value="clear_all_values" /></button> }
            <button className="btn btn-primary col-sm-2 buttonStyle" type="button" disabled={!canSave} onClick={() => {
              this.handleFinish();
            }}><Translate value="save"/></button>
            <button className="btn btn-danger col-sm-2 buttonStyle" type="button" onClick={() => {
              this.props.closeC();
            }}><Translate value="close"/></button>
        </div>
        <Row>
        </Row>
      </ContentWrapper>
    );
  }
}

export default SerialNumModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/serialNumModal.jsx